<template>
  <div>
    <location />
    <div class="page wrap-1200 stats">
      <div class="d-flex justify-content-center align-items-center mb-3">
        <button
          class="btn p-0"
          :class="{
            'text-opacity-25': searchData.searchdate < 2025,
          }"
          @click="prev()"
        >
          <i class="material-icons fs-1">keyboard_arrow_left</i>
        </button>
        <h5 class="mx-2 text-center">
          {{ searchData.searchdate }} {{ $t("text.common.season") }}
        </h5>
        <button
          class="btn p-0"
          :class="{
            'text-opacity-25':
              searchData.searchdate ==
              $dayjs(new Date().setYear(new Date().getFullYear())).format(
                'YYYY',
              ),
          }"
          @click="next()"
        >
          <i class="material-icons fs-1">keyboard_arrow_right</i>
        </button>
      </div>

      <div class="row row-cols-1 row-cols-md-2 gx-lg-5 gy-4">
        <div class="col">
          <h6
            class="subtitle d-flex align-items-center justify-content-between"
          >
            <span>{{ $t("title.common.avg_score") }}</span>
            <div class="btn-group">
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="openModal('Avg.Score', 'avg_score', 'ASC')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_48_1007"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_48_1007)">
                    <path
                      d="M5.5 11.5V13H3.5C3.0875 13 2.73438 12.8531 2.44063 12.5594C2.14688 12.2656 2 11.9125 2 11.5V3.5C2 3.0875 2.14688 2.73438 2.44063 2.44063C2.73438 2.14688 3.0875 2 3.5 2H11.5C11.9125 2 12.2656 2.14688 12.5594 2.44063C12.8531 2.73438 13 3.0875 13 3.5V5.5H11.5V3.5H3.5V11.5H5.5ZM8.5 18C8.0875 18 7.73438 17.8531 7.44063 17.5594C7.14688 17.2656 7 16.9125 7 16.5V8.5C7 8.0875 7.14688 7.73438 7.44063 7.44063C7.73438 7.14688 8.0875 7 8.5 7H16.5C16.9125 7 17.2656 7.14688 17.5594 7.44063C17.8531 7.73438 18 8.0875 18 8.5V16.5C18 16.9125 17.8531 17.2656 17.5594 17.5594C17.2656 17.8531 16.9125 18 16.5 18H8.5ZM8.5 16.5H16.5V8.5H8.5V16.5Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">View Popup</span>
              </b-button>
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="
                  $router
                    .push({
                      name: 'Stats',
                      params: { searchdate: searchData.searchdate },
                      query: {
                        rank_field: 'avg_score',
                        sort: 'ASC',
                      },
                    })
                    .catch(() => {})
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_68_625"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_68_625)">
                    <path
                      d="M9.25 17V10.75H3V9.25H9.25V3H10.75V9.25H17V10.75H10.75V17H9.25Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">{{ $t("button.common.view_all") }}</span>
              </b-button>
            </div>
          </h6>
          <table class="table table-xs">
            <thead>
              <tr>
                <th class="w-1">
                  {{ $t("text.common.ranking_abbr") }}
                </th>
                <th>
                  {{ $t("title.common.player") }}
                </th>
                <th class="w-1">
                  {{ $t("title.common.score") }}
                </th>
              </tr>
            </thead>
            <tbody v-if="summary.top_avg_score_list.length > 0">
              <template v-for="(item, index) in summary.top_avg_score_list">
                <tr :key="index">
                  <td>
                    <strong class="text-black">{{ item.ranking }}</strong>
                  </td>
                  <td class="d-flex align-items-center text-start">
                    <MemberInfo
                      :playerno="item.player_pk"
                      :member_img="item.member_img"
                      :badge_img="item.badge_img"
                      :class_bind="'avatar-md'"
                    />
                    <div>
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.player_pk"
                        :avatar_img="false"
                        class="fw-500"
                      />
                      <p class="fs-12 fw-normal shop-name">
                        {{ item.shopname || "-" }}
                      </p>
                    </div>
                  </td>
                  <td>{{ item.rank_field | toFixed }}</td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col">
          <h6
            class="subtitle d-flex align-items-center justify-content-between gap-1"
          >
            <span>{{ $t("title.common.gir") }}</span>
            <div class="btn-group">
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="openModal('GIR', 'greens', 'DESC')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_48_1007"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_48_1007)">
                    <path
                      d="M5.5 11.5V13H3.5C3.0875 13 2.73438 12.8531 2.44063 12.5594C2.14688 12.2656 2 11.9125 2 11.5V3.5C2 3.0875 2.14688 2.73438 2.44063 2.44063C2.73438 2.14688 3.0875 2 3.5 2H11.5C11.9125 2 12.2656 2.14688 12.5594 2.44063C12.8531 2.73438 13 3.0875 13 3.5V5.5H11.5V3.5H3.5V11.5H5.5ZM8.5 18C8.0875 18 7.73438 17.8531 7.44063 17.5594C7.14688 17.2656 7 16.9125 7 16.5V8.5C7 8.0875 7.14688 7.73438 7.44063 7.44063C7.73438 7.14688 8.0875 7 8.5 7H16.5C16.9125 7 17.2656 7.14688 17.5594 7.44063C17.8531 7.73438 18 8.0875 18 8.5V16.5C18 16.9125 17.8531 17.2656 17.5594 17.5594C17.2656 17.8531 16.9125 18 16.5 18H8.5ZM8.5 16.5H16.5V8.5H8.5V16.5Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">View Popup</span>
              </b-button>
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="
                  $router
                    .push({
                      name: 'Stats',
                      params: { searchdate: searchData.searchdate },
                      query: {
                        rank_field: 'greens',
                        sort: 'DESC',
                      },
                    })
                    .catch(() => {})
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_68_625"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_68_625)">
                    <path
                      d="M9.25 17V10.75H3V9.25H9.25V3H10.75V9.25H17V10.75H10.75V17H9.25Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">{{ $t("button.common.view_all") }}</span>
              </b-button>
            </div>
          </h6>
          <table class="table table-xs">
            <thead>
              <tr>
                <th class="w-1">
                  {{ $t("text.common.ranking_abbr") }}
                </th>
                <th>
                  {{ $t("title.common.player") }}
                </th>
                <th class="w-1">%</th>
              </tr>
            </thead>
            <tbody v-if="summary.top_greens_list.length > 0">
              <template v-for="(item, index) in summary.top_greens_list">
                <tr :key="index">
                  <td>
                    <strong class="text-black">{{ item.ranking }}</strong>
                  </td>
                  <td class="d-flex align-items-center text-start">
                    <MemberInfo
                      :playerno="item.player_pk"
                      :member_img="item.member_img"
                      :badge_img="item.badge_img"
                      :class_bind="'avatar-md'"
                    />
                    <div>
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.player_pk"
                        :avatar_img="false"
                        class="fw-500"
                      />
                      <p class="fs-12 fw-normal shop-name">
                        {{ item.shopname || "-" }}
                      </p>
                    </div>
                  </td>
                  <td>{{ item.rank_field | toFixed | suffix("%") }}</td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col">
          <h6
            class="subtitle d-flex align-items-center justify-content-between gap-1"
          >
            <span>{{ $t("title.common.avg_distance") }}</span>
            <div class="btn-group">
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="openModal('Avg. Driver Distance', 'avg_drive', 'DESC')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_48_1007"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_48_1007)">
                    <path
                      d="M5.5 11.5V13H3.5C3.0875 13 2.73438 12.8531 2.44063 12.5594C2.14688 12.2656 2 11.9125 2 11.5V3.5C2 3.0875 2.14688 2.73438 2.44063 2.44063C2.73438 2.14688 3.0875 2 3.5 2H11.5C11.9125 2 12.2656 2.14688 12.5594 2.44063C12.8531 2.73438 13 3.0875 13 3.5V5.5H11.5V3.5H3.5V11.5H5.5ZM8.5 18C8.0875 18 7.73438 17.8531 7.44063 17.5594C7.14688 17.2656 7 16.9125 7 16.5V8.5C7 8.0875 7.14688 7.73438 7.44063 7.44063C7.73438 7.14688 8.0875 7 8.5 7H16.5C16.9125 7 17.2656 7.14688 17.5594 7.44063C17.8531 7.73438 18 8.0875 18 8.5V16.5C18 16.9125 17.8531 17.2656 17.5594 17.5594C17.2656 17.8531 16.9125 18 16.5 18H8.5ZM8.5 16.5H16.5V8.5H8.5V16.5Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">View Popup</span>
              </b-button>
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="
                  $router
                    .push({
                      name: 'Stats',
                      params: { searchdate: searchData.searchdate },
                      query: {
                        rank_field: 'avg_drive',
                        sort: 'DESC',
                      },
                    })
                    .catch(() => {})
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_68_625"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_68_625)">
                    <path
                      d="M9.25 17V10.75H3V9.25H9.25V3H10.75V9.25H17V10.75H10.75V17H9.25Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">{{ $t("button.common.view_all") }}</span>
              </b-button>
            </div>
          </h6>
          <table class="table table-xs">
            <thead>
              <tr>
                <th class="w-1">
                  {{ $t("text.common.ranking_abbr") }}
                </th>
                <th>
                  {{ $t("title.common.player") }}
                </th>
                <th class="w-1">
                  {{ $t("title.common.distance") }}
                </th>
              </tr>
            </thead>
            <tbody v-if="summary.top_avg_drive_list.length > 0">
              <template v-for="(item, index) in summary.top_avg_drive_list">
                <tr :key="index">
                  <td>
                    <strong class="text-black">{{ item.ranking }}</strong
                    ><br />
                  </td>
                  <td class="d-flex align-items-center text-start">
                    <MemberInfo
                      :playerno="item.player_pk"
                      :member_img="item.member_img"
                      :badge_img="item.badge_img"
                      :class_bind="'avatar-md'"
                    />
                    <div>
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.player_pk"
                        :avatar_img="false"
                        class="fw-500"
                      />
                      <p class="fs-12 fw-normal shop-name">
                        {{ item.shopname || "-" }}
                      </p>
                    </div>
                  </td>
                  <td>
                    {{ item.rank_field | toFixed | suffix("m") }}
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col">
          <h6
            class="subtitle d-flex align-items-center justify-content-between gap-1"
          >
            <span>{{ $t("title.common.avg_putts_distance") }}</span>
            <div class="btn-group">
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="
                  openModal('Avg. Distance of Putts Holed', 'avg_putt', 'DESC')
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_48_1007"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_48_1007)">
                    <path
                      d="M5.5 11.5V13H3.5C3.0875 13 2.73438 12.8531 2.44063 12.5594C2.14688 12.2656 2 11.9125 2 11.5V3.5C2 3.0875 2.14688 2.73438 2.44063 2.44063C2.73438 2.14688 3.0875 2 3.5 2H11.5C11.9125 2 12.2656 2.14688 12.5594 2.44063C12.8531 2.73438 13 3.0875 13 3.5V5.5H11.5V3.5H3.5V11.5H5.5ZM8.5 18C8.0875 18 7.73438 17.8531 7.44063 17.5594C7.14688 17.2656 7 16.9125 7 16.5V8.5C7 8.0875 7.14688 7.73438 7.44063 7.44063C7.73438 7.14688 8.0875 7 8.5 7H16.5C16.9125 7 17.2656 7.14688 17.5594 7.44063C17.8531 7.73438 18 8.0875 18 8.5V16.5C18 16.9125 17.8531 17.2656 17.5594 17.5594C17.2656 17.8531 16.9125 18 16.5 18H8.5ZM8.5 16.5H16.5V8.5H8.5V16.5Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">View Popup</span>
              </b-button>
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="
                  $router
                    .push({
                      name: 'Stats',
                      params: { searchdate: searchData.searchdate },
                      query: {
                        rank_field: 'avg_putt',
                        sort: 'DESC',
                      },
                    })
                    .catch(() => {})
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_68_625"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_68_625)">
                    <path
                      d="M9.25 17V10.75H3V9.25H9.25V3H10.75V9.25H17V10.75H10.75V17H9.25Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">{{ $t("button.common.view_all") }}</span>
              </b-button>
            </div>
          </h6>
          <table class="table table-xs">
            <thead>
              <tr>
                <th class="w-1">
                  {{ $t("text.common.ranking_abbr") }}
                </th>
                <th>
                  {{ $t("title.common.player") }}
                </th>
                <th class="w-1">
                  {{ $t("title.common.distance") }}
                </th>
              </tr>
            </thead>
            <tbody v-if="summary.top_avg_putt_list.length > 0">
              <template v-for="(item, index) in summary.top_avg_putt_list">
                <tr :key="index">
                  <td>
                    <strong class="text-black">{{ item.ranking }}</strong
                    ><br />
                  </td>
                  <td class="d-flex align-items-center text-start">
                    <MemberInfo
                      :playerno="item.player_pk"
                      :member_img="item.member_img"
                      :badge_img="item.badge_img"
                      :class_bind="'avatar-md'"
                    />
                    <div>
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.player_pk"
                        :avatar_img="false"
                        class="fw-500"
                      />
                      <p class="fs-12 fw-normal shop-name">
                        {{ item.shopname || "-" }}
                      </p>
                    </div>
                  </td>
                  <td>
                    {{ item.rank_field | toFixed | suffix("m") }}
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col">
          <h6
            class="subtitle d-flex align-items-center justify-content-between gap-1"
          >
            <span>{{ $t("title.common.par_save_rate") }}</span>
            <div class="btn-group">
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="openModal('Par Save Rate', 'parsave', 'ASC')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_48_1007"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_48_1007)">
                    <path
                      d="M5.5 11.5V13H3.5C3.0875 13 2.73438 12.8531 2.44063 12.5594C2.14688 12.2656 2 11.9125 2 11.5V3.5C2 3.0875 2.14688 2.73438 2.44063 2.44063C2.73438 2.14688 3.0875 2 3.5 2H11.5C11.9125 2 12.2656 2.14688 12.5594 2.44063C12.8531 2.73438 13 3.0875 13 3.5V5.5H11.5V3.5H3.5V11.5H5.5ZM8.5 18C8.0875 18 7.73438 17.8531 7.44063 17.5594C7.14688 17.2656 7 16.9125 7 16.5V8.5C7 8.0875 7.14688 7.73438 7.44063 7.44063C7.73438 7.14688 8.0875 7 8.5 7H16.5C16.9125 7 17.2656 7.14688 17.5594 7.44063C17.8531 7.73438 18 8.0875 18 8.5V16.5C18 16.9125 17.8531 17.2656 17.5594 17.5594C17.2656 17.8531 16.9125 18 16.5 18H8.5ZM8.5 16.5H16.5V8.5H8.5V16.5Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">View Popup</span>
              </b-button>
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="
                  $router
                    .push({
                      name: 'Stats',
                      params: { searchdate: searchData.searchdate },
                      query: {
                        rank_field: 'parsave',
                        sort: 'ASC',
                      },
                    })
                    .catch(() => {})
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_68_625"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_68_625)">
                    <path
                      d="M9.25 17V10.75H3V9.25H9.25V3H10.75V9.25H17V10.75H10.75V17H9.25Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">{{ $t("button.common.view_all") }}</span>
              </b-button>
            </div>
          </h6>
          <table class="table table-xs">
            <thead>
              <tr>
                <th class="w-1">
                  {{ $t("text.common.ranking_abbr") }}
                </th>
                <th>
                  {{ $t("title.common.player") }}
                </th>
                <th class="w-1">%</th>
              </tr>
            </thead>
            <tbody v-if="summary.top_parsave_list.length > 0">
              <template v-for="(item, index) in summary.top_parsave_list">
                <tr :key="index">
                  <td>
                    <strong class="text-black">{{ item.ranking }}</strong>
                  </td>
                  <td class="d-flex align-items-center text-start">
                    <MemberInfo
                      :playerno="item.player_pk"
                      :member_img="item.member_img"
                      :badge_img="item.badge_img"
                      :class_bind="'avatar-md'"
                    />
                    <div>
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.player_pk"
                        :avatar_img="false"
                        class="fw-500"
                      />
                      <p class="fs-12 fw-normal shop-name">
                        {{ item.shopname || "-" }}
                      </p>
                    </div>
                  </td>
                  <td>
                    {{ item.rank_field | toFixed | suffix("%") }}
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col">
          <h6
            class="subtitle d-flex align-items-center justify-content-between gap-1"
          >
            <span>{{ $t("title.common.fareway_hit") }}</span>
            <div class="btn-group">
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="openModal('Fairway Hit', 'fairway', 'DESC')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_48_1007"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_48_1007)">
                    <path
                      d="M5.5 11.5V13H3.5C3.0875 13 2.73438 12.8531 2.44063 12.5594C2.14688 12.2656 2 11.9125 2 11.5V3.5C2 3.0875 2.14688 2.73438 2.44063 2.44063C2.73438 2.14688 3.0875 2 3.5 2H11.5C11.9125 2 12.2656 2.14688 12.5594 2.44063C12.8531 2.73438 13 3.0875 13 3.5V5.5H11.5V3.5H3.5V11.5H5.5ZM8.5 18C8.0875 18 7.73438 17.8531 7.44063 17.5594C7.14688 17.2656 7 16.9125 7 16.5V8.5C7 8.0875 7.14688 7.73438 7.44063 7.44063C7.73438 7.14688 8.0875 7 8.5 7H16.5C16.9125 7 17.2656 7.14688 17.5594 7.44063C17.8531 7.73438 18 8.0875 18 8.5V16.5C18 16.9125 17.8531 17.2656 17.5594 17.5594C17.2656 17.8531 16.9125 18 16.5 18H8.5ZM8.5 16.5H16.5V8.5H8.5V16.5Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">View Popup</span>
              </b-button>
              <b-button
                class="d-flex align-items-center gap-1 btn btn-text ms-auto fs-13 btn-secondary"
                @click="
                  $router
                    .push({
                      name: 'Stats',
                      params: { searchdate: searchData.searchdate },
                      query: {
                        rank_field: 'fairway',
                        sort: 'DESC',
                      },
                    })
                    .catch(() => {})
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <mask
                    id="mask0_68_625"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_68_625)">
                    <path
                      d="M9.25 17V10.75H3V9.25H9.25V3H10.75V9.25H17V10.75H10.75V17H9.25Z"
                      fill="#676D73"
                    />
                  </g>
                </svg>
                <span class="text">{{ $t("button.common.view_all") }}</span>
              </b-button>
            </div>
          </h6>
          <table class="table table-xs">
            <thead>
              <tr>
                <th class="w-1">
                  {{ $t("text.common.ranking_abbr") }}
                </th>
                <th>
                  {{ $t("title.common.player") }}
                </th>
                <th class="w-1">%</th>
              </tr>
            </thead>
            <tbody v-if="summary.top_fairway_list.length > 0">
              <template v-for="(item, index) in summary.top_fairway_list">
                <tr :key="index">
                  <td>
                    <strong class="text-black">{{ item.ranking }}</strong>
                  </td>
                  <td class="d-flex align-items-center text-start">
                    <MemberInfo
                      :playerno="item.player_pk"
                      :member_img="item.member_img"
                      :badge_img="item.badge_img"
                      :class_bind="'avatar-md'"
                    />
                    <div>
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.player_pk"
                        :avatar_img="false"
                        class="fw-500"
                      />
                      <p class="fs-12 fw-normal shop-name">
                        {{ item.shopname || "-" }}
                      </p>
                    </div>
                  </td>
                  <td>
                    {{ item.rank_field | toFixed | suffix("%") }}
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-view-popup"
      modal-class="full-popover"
      ref="modal-view-popup"
      size="xl"
      centered
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ modalTitle }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-view-popup')"
        >
        </b-button>
      </template>
      <template #default>
        <div class="content">
          <div
            class="filter-group row row-cols-2 row-cols-md-4 row-cols-lg-6 g-2 justify-content-between"
          >
            <div class="col-group">
              <span class="time">{{ $dayjs().format("YYYY-MM-DD") }}</span>
            </div>
            <div class="col-group">
              <div class="col">
                <select v-model="selectedCountry" @change="onCountryChange">
                  <option value="">Country</option>
                  <option
                    v-for="item in filterData"
                    :key="item.country_pk"
                    :value="item.country_pk"
                  >
                    {{ item.country_name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <select v-model="selectedState" @change="onStateChange">
                  <option value="">States</option>
                  <option
                    v-for="item in filteredStates"
                    :key="item.states_pk"
                    :value="item.states_pk"
                  >
                    {{ item.states_name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <select v-model="selectedVenue" @change="onVenueChange">
                  <option value="">Venue</option>
                  <option
                    v-for="item in filteredVenues"
                    :key="item.owner_pk"
                    :value="item.owner_pk"
                  >
                    {{ item.shopname }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <table class="table table-xs">
            <colgroup>
              <col style="width: 10%" />
              <col style="width: 80%" />
              <col style="width: 10%" />
            </colgroup>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Nickname</th>
                <th>{{ modalTitle }}</th>
              </tr>
            </thead>
            <tbody v-if="modalLoading">
              <tr>
                <td colspan="3" class="text-center">Loading...</td>
              </tr>
            </tbody>
            <tbody v-else-if="modalList.length > 0">
              <tr v-for="(item, index) in modalList" :key="index">
                <td>{{ item.ranking }}</td>
                <td>
                  <div class="img-area align-left d-flex align-items-center">
                    <MemberInfo
                      :playerno="item.player_pk"
                      :member_img="item.member_img"
                      :badge_img="item.badge_img"
                      :class_bind="'avatar-md'"
                    />
                    <div class="info d-flex flex-column">
                      <span class="name">{{ item.nickname }}</span>
                      <span class="area">{{ item.shopname || "-" }}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="score">
                    {{ item.rank_field | toFixed }}
                  </span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">No data</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template #modal-footer>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-view-popup')"
        >
          {{ $t("button.common.close") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/halloffame";
import { myMixin } from "@/mixin/myMixin";
import "@/filter/common";

export default {
  name: "StatsSummary",
  components: {
    location,
  },
  data() {
    return {
      modalList: [],
      modalTitle: "",
      modalField: "",
      modalSort: "", // 추가
      searchData: {
        searchdate:
          this.$route.query.searchdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchdate) ||
          this.$dayjs(new Date().setYear(new Date().getFullYear())).format(
            "YYYY",
          ),
      },

      summary: {
        top_avg_score_list: [],
        top_greens_list: [],
        top_avg_drive_list: [],
        top_avg_putt_list: [],
        top_parsave_list: [],
        top_fairway_list: [],
      },
      view_hide: null,
      filterData: [],
      selectedCountry: "",
      selectedState: "",
      selectedVenue: "",
      modalLoading: false,
      modalInterval: null,
    };
  },
  computed: {
    filteredStates() {
      if (!this.selectedCountry) return [];
      const country = this.filterData.find(
        (c) => c.country_pk == this.selectedCountry,
      );
      return country ? country.states : [];
    },
    filteredVenues() {
      if (!this.selectedState) return [];
      const country = this.filterData.find(
        (c) => c.country_pk == this.selectedCountry,
      );
      if (!country) return [];
      const state = country.states.find(
        (s) => s.states_pk == this.selectedState,
      );
      return state ? state.venues : [];
    },
  },
  methods: {
    onCountryChange() {
      this.selectedState = "";
      this.selectedVenue = "";
      this.get_modal_list();
    },
    onStateChange() {
      this.selectedVenue = "";
      this.get_modal_list();
    },
    onVenueChange() {
      this.get_modal_list();
    },
    prev() {
      if (this.searchData.searchdate < 2025) return;
      this.searchData.searchdate--;
    },
    next() {
      if (
        this.searchData.searchdate ==
        this.$dayjs(new Date().setYear(new Date().getFullYear())).format("YYYY")
      )
        return;
      this.searchData.searchdate++;
    },
    get_stats_summary() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_stats_summary(this.searchData, (flag, data) => {
        this.summary = data.summary;

        if (!flag) alert(data.message);
      });
    },
    onSubmit(event) {
      event.preventDefault();
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    openModal(title, rank_field, sort) {
    this.modalTitle = title;
    this.modalField = rank_field;
    this.modalSort = sort;
    this.modalList = [];
    this.filterData = [];
    this.selectedCountry = "";
    this.selectedState = "";
    this.selectedVenue = "";
    this.modalLoading = true;
    this.$bvModal.show("modal-view-popup");
    this.get_modal_list();
    this.get_stats_filter();

    // 기존 인터벌 있으면 정리 후 새로 시작
    this.clearModalInterval();
    this.modalInterval = setInterval(() => {
      this.get_modal_list();
    }, 60000);
  },

  get_modal_list() {
    this.modalLoading = true;
      ax.get_livestatslist(
        {
          rank_field: this.modalField,
          sort: this.modalSort,
          searchdate: this.searchData.searchdate,
          pageno: 1,
          pagesize: 20,
          country_fk: this.selectedCountry,
          states_fk: this.selectedState,
          owner_fk: this.selectedVenue,
        },
        (flag, data) => {
          this.modalLoading = false;
          if (flag) {
            this.modalList = data.list;
          } else {
            alert(data.message);
          }
        },
      );
    },
    clearModalInterval() {
      if (this.modalInterval) {
        clearInterval(this.modalInterval);
        this.modalInterval = null;
      }
    },
    get_modal_list() {
      this.modalLoading = true;
      ax.get_livestatslist(
        {
          rank_field: this.modalField,
          sort: this.modalSort,
          searchdate: this.searchData.searchdate,
          pageno: 1,
          pagesize: 20,
          country_fk: this.selectedCountry,
          states_fk: this.selectedState,
          owner_fk: this.selectedVenue,
        },
        (flag, data) => {
          this.modalLoading = false;
          if (flag) {
            this.modalList = data.list;
          } else {
            alert(data.message);
          }
        },
      );
    },

    get_stats_filter() {
      ax.get_stats_filter(
        {
          rank_field: this.modalField,
          sort: this.modalSort,
          searchdate: this.searchData.searchdate,
        },
        (flag, data) => {
          if (flag) {
            this.filterData = data.filter;
          }
        },
      );
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId === "modal-view-popup") {
        this.clearModalInterval();
      }
    });
  },
  beforeDestroy() {
    this.clearModalInterval();
  },
  created() {
    this.get_stats_summary();
  },
  watch: {
    "searchData.searchdate": function () {
      this.get_stats_summary();
    },
  },
  mixins: [myMixin],
};
</script>
<style lang="scss" scoped>
#modal-view-popup {
  .content {
    .filter-group {
      margin-bottom: 12px;
      align-items: flex-end;

      .col-group {
        display: flex;
        gap: 8px;
        width: auto;

        .time {
          font-size: 14px;
          font-weight: 500;
          font-family: "Roboto";
          color: #ff7519;
        }

        .col {
          select {
            min-width: 160px;
            border-radius: 6px !important;
          }
        }
      }
    }
  }
}

.btn-group {
  .text {
    text-decoration: underline;
    text-underline-offset: 3px;
    font-size: 13px;
  }
}

@media (max-width: 991.98px) {
  #modal-view-popup {
    .content {
      .filter-group {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;

        .col-group {
          width: 100%;

          .col {
            flex: 1;

            select {
              min-width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
